import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import EditButton from "../shared/button/EditButton";
import companySpecialitiesType from "./types/companySpecialitiesType";
import CompanySpecialitiesEdit from "./EditForms/CompanySpecialitiesEdit";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import {
  Wrapper,
  Title,
  Body,
  Speciality,
  SpecialityText,
} from "./styles/company-specialities-styles";

export class CompanySpecialities extends Component {
  state = {
    editSpecialitiesActive: false,
  };

  toggleEditSpecialities = () => {
    this.setState(({ editSpecialitiesActive }) => ({
      editSpecialitiesActive: !editSpecialitiesActive,
    }));
  };

  render() {
    const { currentUser, specialitiesFormLoading, companySpecialities } =
      this.props;
    const { editSpecialitiesActive } = this.state;

    return (
      <Wrapper
        className="animated delay-4 fadeIn"
        editSpecialitiesActive={editSpecialitiesActive}
      >
        {specialitiesFormLoading && <WidgetLoading />}
        {editSpecialitiesActive && (
          <CompanySpecialitiesEdit
            toggleEditSpecialities={this.toggleEditSpecialities}
          />
        )}
        {currentUser.isRecruiter && (
          <EditButton
            onClickAction={this.toggleEditSpecialities}
            top={8}
            right={10}
          />
        )}
        <Title>Specialities</Title>
        {companySpecialities.length < 1 ? (
          <Body noData>
            {currentUser.isRecruiter
              ? "Please add your information here"
              : "We're working on building our profile right now"}
          </Body>
        ) : (
          <Body>
            {companySpecialities.map((speciality) => (
              <Speciality key={speciality ? speciality.replace(" ", "-") : ""}>
                <FontAwesomeIcon icon={faCheck} />
                <SpecialityText data-test-id="user-speciality">
                  {speciality}
                </SpecialityText>
              </Speciality>
            ))}
          </Body>
        )}
      </Wrapper>
    );
  }
}

CompanySpecialities.propTypes = {
  companySpecialities: companySpecialitiesType.isRequired,
  user: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
  }).isRequired,
  currentUser: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
  }).isRequired,
  specialitiesFormLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  companySpecialities: state.agencyProfile.profileData.companySpecialities,
  user: state.agencyProfile.profileData.user,
  currentUser: state.agencyProfile.profileData.currentUser,
  specialitiesFormLoading: state.agencyProfile.specialitiesFormLoading,
});

export default connect(mapStateToProps, {})(CompanySpecialities);
